/*
 * Ryan O'Dowd
 * 2019-05-14
 * © Copyright 2020 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import globals from '@utils/globals';

const getStyles = ({colors}) => {
  return {
    subTitle: {
      display: 'flex',
      color: colors.white,
    },
    paragraph: {
      marginBottom: 16,
    },
    imagesWrapper: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      width: '100%',
      justifyContent: 'space-around',
    },
    image: {
      borderRadius: 32,
      borderStyle: 'solid',
      borderWidth: 5,
      borderColor: colors.primaryLight,
      width: 205,
      height: 444,
      margin: 16,
    },
    missionAndVisionWrapper: {
      borderStyle: 'solid',
      borderWidth: 3,
      borderColor: colors.primaryLight,
      borderRadius: 16,
      backgroundColor: colors.primaryDark,
      padding: 24,
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
      marginBottom: 16,
      fontSize: '1.2em',
    },
    accentTitle: {
      color: colors.accent,
      fontWeight: 'bold',
    },
    statsWrapper: {
      display: 'inline',
      flexDirection: 'row',
      alignItems: 'flex-end',
      flexWrap: 'wrap',
    },
    statText: {
      display: 'inline',
      fontWeight: 'bold',
      color: colors.accent,
    },
    impactText: {
      display: 'inline',
      flexDirection: 'row',
      color: colors.white,
    },

    contactAndDownloadWrapper: {
      display: 'flex',
      flexDirection: window.innerWidth > globals.mediaQuerySizes.sm ? 'row' : 'column', // @TODO: not responsive...listen to changes to width or use mui grid
      width: '100%',
      justifyContent: 'space-between',
      gap: 16,
    },
    contactWrapper: {
      minWidth: '50%',
    },
    downloadCtaWrapper: {
      flex: 1,
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },

    dialogContent: {
      flex: 1,
    },
    dialogActions: {
      flexGrow: 0,
      flexShrink: 1,
    },
    passageWrapper: {
      marginBottom: 8,
      padding: 8,
      paddingBottom: 0,
      backgroundColor: colors.primary,
      borderRadius: 12,
      borderColor: colors.primaryLight,
      borderWidth: 4,
    },
    rightActionButtons: {
      flex: 0.5,
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'flex-end',
      alignItems: 'flex-end',
      gap: 8,
    },
    actionIconButton: {
      display: 'flex',
      margin: 0,
      alignSelf: 'flex-start',
      justifySelf: 'center',
      backgroundColor: colors.primary,
    },
  };
};

export default getStyles;
